<template>
  <div class="simple-landing-logo">
    <div class="simple-landing-logo__kaia" />
    <img
      v-if="landingPage?.logo"
      :src="landingPage.logo"
      :alt="landingPage.displayTitle || 'logo'"
      class="simple-landing-logo__corporate"
    />
    <span
      v-else-if="landingPage?.displayTitle"
      class="simple-landing-logo__corporate"
    >
      {{ landingPage.displayTitle }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import useLandingPageStore from '@shared/stores/useLandingPageStore.js'

const landingPageStore = useLandingPageStore()
const landingPage = computed(() => landingPageStore.landingPage || null)
</script>

<style lang="scss">
.simple-landing-logo {
  background-color: transparent;
  width: 100%;
  @include flex-container(row, center, md, center);

  @include media-up(md) {
    @include flex-container(row, flex-start, md, center);
  }

  &__kaia {
    background-image: url('@shared/assets/img/kaia_text_logo.svg');
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
    height: 15px;
    width: 100px;

    @include media-up(md) {
      background-image: url('@shared/assets/img/kaia_img_logo.svg');
      height: 80px;
      width: 80px;
    }
  }

  &__corporate {
    max-height: 64px;
    max-width: 200px;

    @include media-up(md) {
      max-height: 80px;
      max-width: 272px;
    }
  }
}
</style>
